window.addEventListener('load', function () {
  const selectors = {
    ingredientAboutOverlayTop:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__about',
    ingredientOriginOverlayTop:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__origin',
    ingredientAboutOverlayTopActive:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__about--active',
    ingredientOriginOverlayTopActive:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__origin--active',
    ingredientAboutBtn:
      '.our-approach__ingredients__content__slider__wrapper__item__info__btn__about',
    ingredientOriginBtn:
      '.our-approach__ingredients__content__slider__wrapper__item__info__btn__origin',
    aboutCloseBtn:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__about__close',
    originCloseBtn:
      '.our-approach__ingredients__content__slider__wrapper__item__top__overlay__origin__close',
    ingredientTopWrapper:
      '.our-approach__ingredients__content__slider__wrapper__item__top'
  }

  // const ingredientTopWrappers = document.querySelectorAll(
  //   selectors.ingredientTopWrapper
  // )
  const ingredientAboutBtns = document.querySelectorAll(
    selectors.ingredientAboutBtn
  )
  const ingredientOriginBtns = document.querySelectorAll(
    selectors.ingredientOriginBtn
  )

  const ingredientsNavPrev = document.querySelector(
    '.our-approach__ingredients__header__slider-controls__prev'
  )
  const ingredientsNavNext = document.querySelector(
    '.our-approach__ingredients__header__slider-controls__next'
  )

  const ingredientsSlider = new Swiper(
    '.our-approach__ingredients__content__slider',
    {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 8,
          navigation: false
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 8,
          grabCursor: true
        }
      }
    }
  )

  const showAboutOverlay = (e, type) => {
    const top = e.target.closest(
      '.our-approach__ingredients__content__slider__wrapper__item'
    )
    const aboutOverlay = top.querySelector(selectors.ingredientAboutOverlayTop)

    if (window.innerWidth < 768 && type === 'clicked') {
      aboutOverlay.style.display = 'flex'
    } else if (window.innerWidth > 767 && type === 'hovered') {
      aboutOverlay.style.display = 'flex'
    } else {
      return
    }
  }

  const showOriginOverlay = (e) => {
    const top = e.target.closest(
      '.our-approach__ingredients__content__slider__wrapper__item'
    )
    const originOverlay = top.querySelector(
      selectors.ingredientOriginOverlayTop
    )

    if (window.innerWidth < 768) {
      originOverlay.style.display = 'flex'
    } else {
      originOverlay.style.display = 'flex'
    }
  }

  const hideAboutOverlay = (e, type) => {
    const top = e.target.closest(
      '.our-approach__ingredients__content__slider__wrapper__item'
    )
    const aboutOverlay = top.querySelector(selectors.ingredientAboutOverlayTop)

    if (window.innerWidth < 768 && type === 'clicked') {
      return
    } else if (window.innerWidth > 767 && type === 'hovered') {
      aboutOverlay.style.display = 'none'
    } else {
      return
    }
  }

  const hideOriginOverlay = (e) => {
    const top = e.target.closest(
      '.our-approach__ingredients__content__slider__wrapper__item'
    )
    const originOverlayTop = top.querySelector(
      selectors.ingredientOriginOverlayTop
    )

    if (window.innerWidth < 768) {
      originOverlayTop.style.display = 'none'
    } else {
      originOverlayTop.style.display = 'none'
    }
  }

  if (ingredientAboutBtns.length) {
    ingredientAboutBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', function (e) {
        showAboutOverlay(e, 'hovered')
      })
      btn.addEventListener('click', function (e) {
        showAboutOverlay(e, 'clicked')
      })
      btn.addEventListener('mouseleave', function (e) {
        hideAboutOverlay(e, 'hovered')
      })
      btn.addEventListener('click', function (e) {
        hideAboutOverlay(e, 'clicked')
      })
    })

    // ingredientTopWrappers.forEach(function (wrapper) {
    //   wrapper.addEventListener('mouseenter', showOriginOverlay)
    //   wrapper.addEventListener('mouseleave', hideOriginOverlay)
    //   wrapper.addEventListener('click', showOriginOverlay)
    // })

    ingredientOriginBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', showOriginOverlay)
      btn.addEventListener('mouseleave', hideOriginOverlay)
      btn.addEventListener('click', showOriginOverlay)
    })
  }

  function attachAboutCloseBtns() {
    const aboutCloseBtns = document.querySelectorAll(selectors.aboutCloseBtn)

    if (!aboutCloseBtns.length) {
      return
    }

    aboutCloseBtns.forEach(function (btn) {
      const top = btn.closest(
        '.our-approach__ingredients__content__slider__wrapper__item'
      )
      const aboutOverlay = top.querySelector(
        selectors.ingredientAboutOverlayTop
      )
      btn.addEventListener('click', function () {
        aboutOverlay.style.display = 'none'
      })
    })
  }

  function attachOriginCloseBtns() {
    const originCloseBtns = document.querySelectorAll(selectors.originCloseBtn)

    if (!originCloseBtns.length) {
      return
    }

    originCloseBtns.forEach(function (btn) {
      const top = btn.closest(
        '.our-approach__ingredients__content__slider__wrapper__item'
      )
      const originOverlay = top.querySelector(
        selectors.ingredientOriginOverlayTop
      )
      
      btn.addEventListener('click', function () {
        originOverlay.style.display = 'none !important' 
      })
    })
  }

  function attachIngredientNavButtons() {
    if (!ingredientsNavPrev || !ingredientsNavNext) {
      return
    }

    ingredientsNavPrev.addEventListener('click', () =>
      ingredientsSlider.slidePrev()
    )

    ingredientsNavNext.addEventListener('click', () =>
      ingredientsSlider.slideNext()
    )
  }

  attachAboutCloseBtns()
  attachOriginCloseBtns()
  attachIngredientNavButtons()
})
